import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import injectSheet from 'react-jss'
import exportStyle from './exportStyle'
import style from './style'
import logo from 'images/logo'
import { connect } from 'react-redux'
import { updateProjectAction, mergePermalinkProjectAction } from 'actions/projectActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'
import ifExport from 'helpers/ifExport'
import exportProps from './exportProps'
import { cameraModelImageReadyAction } from 'actions/exportActions'
import ExportDropdown from './ExportDropdown'
import ProjectTitle from './ProjectTitle'
import WireDistanceWarning from 'components/Wire/DistanceWarning'
import tippy from 'tippy.js'
import { deviceCountSelector } from 'selectors/components'

const mapStateToProps = state => {
  const { projects, currentProjectMetadata, messages, permalink, offline, ui: { titleChanged } } = state
  const project = projects.find(p => p.id === currentProjectMetadata._id)

  return {
    projectTitle: project && project.title,
    messages,
    permalink,
    offline,
    titleChanged,
    deviceCount: deviceCountSelector(state)
  }
}

class TopBar extends React.Component {
  componentDidMount() {
    [this.refs.cloneLink, this.refs.shareLink]
      .forEach(ref => tippy(ref, { duration: 0, theme: 'topbar', placement: 'bottom' }))
  }

  isBlankProject = _ => {
    const { projectTitle, titleChanged, deviceCount } = this.props
    return projectTitle === 'New Project' && !titleChanged && deviceCount === 0
  }

  render() {
    const { messages, updateProjectAction, projectTitle, permalink, offline, titleChanged,
      mergePermalinkProjectAction, checkOfflineLimitsAction, classes } = this.props

    return (
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.topRow}>
            <div className={classes.leftSideThings}>
              <div className={classes.logoWrapper}>
                <a href={IPVM_URL}>
                  <img src={logo} alt='IPVM Logo' />
                </a>
              </div>
              <div className={classes.projectInputsWrapper}>
                <a
                  onClick={_ => checkOfflineLimitsAction('listProjects')}
                  className={classes.allProjectsButton}
                >
                  <FontAwesomeIcon icon='list' className={classes.listIcon} />
                  All Projects
                </a>
                <a
                  onClick={_ => !this.isBlankProject() && checkOfflineLimitsAction('newProject')}
                  className={classes.leftSideButton}
                  disabled={this.isBlankProject()}
                >
                  <FontAwesomeIcon icon='plus' className={classes.addIcon} />
                  New Project
                </a>
              </div>
            </div>
            <div className={classes.rightSideThings}>
              <div className={classes.inputAndButtonsWrapper}>
                <div className={classes.titleWrapper}>
                  {
                    permalink && !offline
                    ? <div>You are viewing a permalink project. <a><strong onClick={mergePermalinkProjectAction}>Make it a part of your projects.</strong></a></div>
                    : <ProjectTitle title={projectTitle} callback={updateProjectAction} titleChanged={titleChanged} />
                  }
                </div>
                {!permalink && <div className={classes.messagesWrapper}>
                  <span>
                    {!!messages && messages.saveState}
                  </span>
                </div>}
                <div style={{ display: 'flex' }}>
                  <div>
                    <a
                      onClick={_ => checkOfflineLimitsAction('modal', ['Permalink'])}
                      className={classes.permalinkButton}
                      title='Generate a public link to share your project with whomever you want'
                      ref='shareLink'
                    >
                      <FontAwesomeIcon icon='link' className={classes.permalinkIcon} />
                      Share
                    </a>
                    <a
                      onClick={_ => checkOfflineLimitsAction('duplicateProject')}
                      className={classes.cloneButton}
                      title='Duplicates current project'
                      ref='cloneLink'
                    >
                      <FontAwesomeIcon icon='copy' className={classes.cloneIcon} />
                      Clone
                    </a>
                  </div>
                  <ExportDropdown />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const CameraAttrDisplay = ({ info }) => <span><strong>{info[0]}:</strong> {info[1]}</span>

const ExportTopBar = ({ firstRow, secondRow, thirdRow, imageUrl, cameraModelImageReadyAction, imagerId, networkCloset, wireDistance, showWarning, isImperial, classes }) =>
  <div className={classes.container}>
    <div className={classes.exportContent}>
      <div className={classes.exportTopRow}>
        { imageUrl && <img src={imageUrl} onLoad={cameraModelImageReadyAction} className={classes.modelImage} /> }
        <div className={classes.cameraInfo}>
          <div>
            { firstRow.map((arr, i) => <CameraAttrDisplay info={arr} key={i} />) }
          </div>
          <div>
            { secondRow.map((arr, i) => <CameraAttrDisplay info={arr} key={i} />) }
          </div>
          <div>
            { thirdRow.map((arr, i) => <CameraAttrDisplay info={arr} key={i} />) }
          </div>
        </div>
        { networkCloset &&
          <div className={classes.wiringInfo}>
            <strong>{ imagerId && 'Main Unit ' }Cable Calculations:</strong>
            <span>
              <FontAwesomeIcon
                icon='server'
                className={classes.networkClosetIcon}
                style={{ color: networkCloset.color }}
              />
              { networkCloset.name }
            </span>
            <span>
              Length: { wireDistance }
              { showWarning && <WireDistanceWarning isImperial={isImperial} /> }
            </span>
          </div>
        }
      </div>
    </div>
  </div>

export default connect(
  ifExport(exportProps, mapStateToProps),
  { mergePermalinkProjectAction, checkOfflineLimitsAction,
    updateProjectAction, cameraModelImageReadyAction }
)(EXPORT ? injectSheet(exportStyle)(ExportTopBar) : injectSheet(style)(TopBar))



// WEBPACK FOOTER //
// ./src/components/TopBar/index.js